'use client'

import React, { HTMLAttributes, ReactNode, useState } from 'react'

import { clsx } from 'clsx'

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  isOpen: boolean
}

// Grid-rows collapse. Content is only clipped while closed or animating, so focus outlines and
// other overflowing decorations aren't cut off once it is open.
export const Collapse = ({ children, className, isOpen, ...rest }: Props): React.ReactElement => {
  const [transitionSettled, setTransitionSettled] = useState<boolean>(isOpen)
  const [previousIsOpen, setPreviousIsOpen] = useState<boolean>(isOpen)

  if (previousIsOpen !== isOpen) {
    setPreviousIsOpen(isOpen)
    setTransitionSettled(false)
  }

  return (
    <div
      {...rest}
      className={clsx(
        'grid transition-[grid-template-rows] duration-200 ease-in-out',
        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        className
      )}
      onTransitionEnd={(event) => {
        if (event.target === event.currentTarget && event.propertyName === 'grid-template-rows') setTransitionSettled(true)
      }}
    >
      <div className={clsx('min-h-0', (!isOpen || !transitionSettled) && 'overflow-hidden')} inert={!isOpen}>
        {children}
      </div>
    </div>
  )
}
